import { EventEmitter, Injectable } from '@angular/core';
import { debounceTime, lastValueFrom } from 'rxjs';
import moment from 'moment';
import { Storage } from '@ionic/storage';
import { TranslateService } from '@ngx-translate/core';


@Injectable({
  providedIn: 'root'
})
export class LangService {

  private langEmitter = new EventEmitter<string>();

  constructor(
    private storage: Storage,
    private translateService: TranslateService
  ) {
    this.langEmitter = new EventEmitter<string>();
    this.langEmitter.pipe(debounceTime(100)).subscribe(lang => {
      console.log('lang changed', lang);
      this.setLang(lang).then();
    });
  }

  public langEmitterHandler = (lang: string) => this.langEmitter.emit(lang);

  private setLang = async (lang: string): Promise<void> => {
    moment.locale(lang);
    await lastValueFrom(this.translateService.use(lang));
    await this.storage.set('lang', lang);
  };
}
